import React from 'react';
import withIcon from '../utilities/withIcon';

const IconXCircle = () => {
  return (
    <g>
      <path d="m13.6233 2.3787a7.95 7.95 0 1 0 -11.2427 11.2426 7.95 7.95 0 0 0 11.2427-11.2426zm-1.0606 10.1821a6.45 6.45 0 1 1 -9.1215-9.1216 6.45 6.45 0 1 1 9.1216 9.1216z" />
      <path d="m10.8987 5.1033a.75.75 0 0 0 -1.0605 0l-1.8365 1.8367-1.8364-1.8367a.75.75 0 1 0 -1.0606 1.0605l1.8365 1.8362-1.8365 1.8367a.75.75 0 1 0 1.0605 1.0605l1.8365-1.8364 1.8364 1.8364a.75.75 0 1 0 1.0605-1.0605l-1.8363-1.8367 1.8364-1.8364a.75.75 0 0 0 0-1.0603z" />
    </g>
  );
};

export default withIcon(IconXCircle);
